import { apiSlice } from "./api/apiSlice";

export const tsActivitySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get TS Activity Report
    getTsActivityReport: builder.query({
      query: ({ start, end, staff, project }) => {
        const params = new URLSearchParams();
        params.append("start", start);
        params.append("end", end);
        
        if (staff && Array.isArray(staff) && staff.length > 0) {
          params.append("staff", JSON.stringify(staff));
        }
        
        if (project) {
          params.append("project", project);
        }
        
        return `/telesales/kpis/activity-report?${params.toString()}`;
      },
      providesTags: ["Telesale"],
      transformResponse: (response) => {
        if (response.success) {
          return {
            data: response.data || [],
            leadsWorking: response.leadsWorking || [],
            overdueLeads: response.overdueLeads || [],
            overdueTasksByType: response.overdueTasksByType || {}
          };
        }
        return {
          data: [],
          leadsWorking: [],
          overdueLeads: [],
          overdueTasksByType: {}
        };
      },
    }),
  }),
});

export const {
  useGetTsActivityReportQuery,
  useLazyGetTsActivityReportQuery,
} = tsActivitySlice;

